import { AxiosResponse } from "axios";
import { Http } from "../../Utils/Http";
import { IAPIErrorResponse } from "../Interfaces/Base/IAPIErrorResponse";
import { IResponse } from "../Interfaces/Base/IResponse";
import { ISaveLead } from "../Interfaces/Request/Lead/ISaveLead";
import { IResponseLead } from "../Interfaces/Responses/Lead/IResponseLead";

export interface ILeadAPI {
  fetchLead(
    data: ISaveLead
  ): Promise<AxiosResponse<IResponse<IResponseLead> | IAPIErrorResponse>>;
}

class LeadAPI implements ILeadAPI {
  async fetchLead(
    data: ISaveLead
  ): Promise<AxiosResponse<IResponse<IResponseLead> | IAPIErrorResponse>> {
    const axios = await Http.axios();
    const response = axios.post<IResponse<IResponseLead> | IAPIErrorResponse>(
      `/api/Leads/add`,
      data
    );
    return response;
  }
}

const instance = new LeadAPI();

export default instance;
